export default __webpack_public_path__ + "static/media/undraw_data_processing.0e1810ba.svg";